import { useEffect, useState } from 'react'
import { consumirApi } from '../utils/consumoApi'
import { API_BASE_URL } from './../utils/config.js' 
import { agregarDatosEmpresaUsuario } from '../utils/empresaUsuario'
import ErrorAlert from '../components/common/ErrorAlert.jsx'
import Table from './../components/tables/TableFilter'
import Button from './../components/common/Button'
import Modal from './../components/modals/Modal'
import ModalConfirmacion from './../components/modals/ModalConfirmacion'
import Form from './../components/forms/Form'
import Input from './../components/common/Input'
import Notification from './../components/common/Notification'
import Spinner from './../components/common/Spinner'
import { FaFileExcel  } from "react-icons/fa"

const Clientes = () => {
  const [datos, setDatos] = useState([])
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
  // campos 
  const [idCliente, setIdCliente] = useState("")
  const [tipoPersona, setTipoPersona] = useState("0")
  const [documento, setDocumento] = useState("")
  const [nombres, setNombres] = useState("")
  const [domicilio, setDomicilio] = useState("")
  const [telefono, setTelefono] = useState("")
  const [sexo, setSexo] = useState("0")
  // modales 
  const [mostrarModal, setMostrarModal] = useState(false)
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
  // notificaciones y cargas 
  const [cargando, setCargando] = useState(true)
  const [cargandoReniec, setCargandoReniec] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  // eliminar un cliente 
  const [selectedId, setSelectedId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //datos para la tabla
  const columnas = [
    { titulo: 'Tipo documento', campo: 'tipo_persona' },
    { titulo: 'Documento', campo: 'documento_cliente' },
    { titulo: 'Nombres', campo: 'nombres_cliente' },
    { titulo: 'Domicilio', campo: 'domicilio_cliente' },
    { titulo: 'Telefono', campo: 'telefono_cliente' },
    { titulo: '', campo: 'sexo' },
  ]

  // Carga inicial de los clientes
  useEffect(() => { obtenerClientes() }, [])

  // Funcion para buscar en la BD de RENIEC el DNI
  const obtenerPersona = async (dni) => {
    setDocumento(dni)
    setNombres('')
    if (dni.length === 8 && tipoPersona === '0') {
      setCargandoReniec(true)
      const respuesta = await consumirApi('GET', `reniec/${dni}`)
      const datos = respuesta.data[0]
      if (datos) {
        setNombres(datos.nombre + ' ' + datos.ape_pat + ' ' + datos.ape_mat)
      }
      setCargandoReniec(false)
    }
  }

  // Funcion para obtener los clientes
  const obtenerClientes = async () => {
    const respuesta = await consumirApi('GET', `maestros/cliente/${idEmpresa}`)
    setDatos(respuesta.success ? respuesta.data : respuesta.error)
    setCargando(false)
  }

  // Funcion para registrar un nuevo cliente
  const registrarCliente = (async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    agregarDatosEmpresaUsuario(formData)
    setIsSubmitting(true)
    const respuesta = await consumirApi('POST', `maestros/cliente`, formData)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "registro", mensaje: "Cliente registrado correctamente" })
      limpiarCampos()
      obtenerClientes()
    }
    else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  })

  // funcion para abrir el modal para editar cliente
  const abrirModalEditar =  (data) => {
    setIdCliente(data.id)
    setTipoPersona(data.tipo_persona== true ? "1" : "0")
    setDocumento(data.documento_cliente)
    setNombres(data.nombres_cliente)
    setDomicilio(data.domicilio_cliente)
    setTelefono(data.telefono_cliente)
    setSexo(data.sexo == true ? "1" : "0")
    setMostrarModalEditar(true)
  }

  // Edición cliente
  const enviarEdicionCliente = async (e) => {
    e.preventDefault()
    const data = { documento_cliente: documento, nombres_cliente: nombres, domicilio_cliente: domicilio, telefono_cliente: telefono, sexo }
    setIsSubmitting(true)
    const respuesta = await consumirApi('PATCH', `maestros/cliente/${idCliente}`, data)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Cliente actualizado correctamente" })
      limpiarCampos()
      obtenerClientes()
    } else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  }

  // Manejar selección de checkbox
  const seleccionCliente = (data) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
  }

  const eliminarCliente = async () => {
    const respuesta = await consumirApi('DELETE', `maestros/cliente/${selectedId}`)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Cliente eliminado correctamente" })
      limpiarCampos()
      obtenerClientes()
    } else {
      setError(respuesta.error)
    }
  }


  const limpiarCampos = () => {
    setMostrarModal(false)
    setMostrarModalEditar(false)
    setMostrarModalEliminar(false)
    setError('')
    setSelectedId(null)
    setDocumento('')
    setNombres('')
    setDomicilio('')
    setTelefono('')
    setTimeout(() => {
      setIsSubmitting(false)
    }, 300)
  }

  return (
    <div className='w-full min-h-[calc(100vh-50px)]'>
      <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
      <Button className="ml-3 mt-2" type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
      <FaFileExcel size={30} color="green" className="ml-3 mt-0 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/clientes/${idEmpresa}`, "_blank")} />
      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : (
        datos.length === 0 ? (
          <div className="ml-5">No se encontraron clientes</div>
        ) : (
          <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
            mostrarChecks={true}
            seleccionFila={seleccionCliente} // Manejar el ID seleccionado
            selectedId={selectedId} // Manejar el ID seleccionado
          />
        )
      )}

      {/* Modal Registrar nuevo cliente*/}
      <Modal isOpen={mostrarModal} title="Registrar nuevo cliente" onClose={limpiarCampos} >
        <Form onSubmit={registrarCliente} isSubmitting={isSubmitting}>
          <Input name="tipo_persona" value={tipoPersona} label="Tipo de documento" type="select" onChange={setTipoPersona}
            options={[
              { value: "0", label: "DNI" },
              { value: "1", label: "RUC" },
            ]}
          />
          <Input name="documento_cliente" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_cliente" value={nombres} label="Nombres" onChange={setNombres} />
          <Input name="domicilio_cliente" value={domicilio} label="Domicilio" onChange={setDomicilio} />
          <Input name="telefono_cliente" value={telefono} label="Telefono" onChange={setTelefono} />
          {
            tipoPersona === "0" &&
            <Input name="sexo" value={sexo} label="Sexo" type="select" onChange={setSexo}
            options={[
              { value: "0", label: "Masculino" },
              { value: "1", label: "Femenino" },
            ]}
            />
          }
         
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal Actuazliar cliente*/}
      <Modal isOpen={mostrarModalEditar} title="Actualizar Cliente" onClose={limpiarCampos} >
        <Form onSubmit={enviarEdicionCliente}  isSubmitting={isSubmitting} type='update'>
          <Input name="documento_cliente" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_cliente" value={nombres} label="Nombres" onChange={setNombres} />
          <Input name="domicilio" value={domicilio} label="Domicilio" onChange={setDomicilio} />
          <Input name="telefono" value={telefono} label="Telefono" onChange={setTelefono} />
          {
            tipoPersona === "0" &&
            <Input name="sexo" value={sexo} label="Sexo" type="select" onChange={setSexo}
              options={[
                { value: "0", label: "Masculino" },
                { value: "1", label: "Femenino" },
              ]}
            />
          }
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal de confirmación para eliminar un cliente*/}
      <ModalConfirmacion
        isOpen={mostrarModalEliminar}
        onClose={limpiarCampos}
        onConfirm={eliminarCliente}
        mensaje="¿Estás seguro de que deseas eliminar cliente?"
      >
        {error && <ErrorAlert message={error} />}
      </ModalConfirmacion>
    </div>
  )
}

export default Clientes
